import { render, staticRenderFns } from "./processRenewals.vue?vue&type=template&id=5d715f34&"
import script from "./processRenewals.vue?vue&type=script&lang=js&"
export * from "./processRenewals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports